export const DASHBOARD_TAB_LABELS = {
  DASHBOARD: 'Dashboard',
  QUANTUM_CALENDAR: 'Quantum Calendar',
  PORTFOLIO_REPORT: 'Portfolio Report',
  PC_ANALYTICS: 'PC Analytics',
};

export const TASK_FILTER = {
  ALL: 'All',
};

export const ESCALATED_MESSAGES = {
  DEFAULT: 'Reach out to the assigned team to get this moving again.',
  LONG_OVERDUE: 'Follow up with the owner, or reassign it to keep the quarter on schedule.',
  LONG_OVERDUE_THRESHOLD_DAYS: 10,
};

export const ESCALATION_OVERDUE_DAYS = 14;

export const TASK_ACTION_DEFAULTS = {
  UPLOAD_SUBTYPE: 'attachment',
  UPLOAD_LABEL: '[Upload]',
  FALLBACK_ACTION: 'View',
};

export const TASK_TYPE_DROPDOWN_PREFIX = 'Task Type: ';
